export interface EnvConfig {
  NEXT_PUBLIC_CLIENT_SIDE_API_URL: string;
  NEXT_PUBLIC_CARTO_BASEMAPS_KEY?: string;
  NEXT_PUBLIC_ENV?: string;
  [key: string]: string | undefined;
}

declare global {
  interface Window {
    __ENV?: Partial<EnvConfig>;
  }
}

export const getEnv = (): EnvConfig => {
  return {
    ...(window.__ENV || {}),
  } as EnvConfig;
};
